export default __webpack_public_path__ + "static/media/video.b65a9a56.png";